import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import Scrollspy from 'react-scrollspy';
import CountUp from 'react-countup';
import './styles.scss';

const MENU_ITEM_HEADERS = [
  'Main information',
  'Facts about the company',
  'What do you do?',
  'Offices',
  'Markets and clients',
  'Social media and articles',
];

export default class Menu extends PureComponent {
  static propTypes = {
    contentRef: PropTypes.object,
    data: PropTypes.object.isRequired,
    menuIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    setScroll: PropTypes.func.isRequired,
  };

  state = {
    menuItems: [],
    oldProgress: 0,
    progress: this.props.data.completeness,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.contentRef !== this.props.contentRef) {
      this.setState({ menuItems: nextProps.contentRef.children });
    }

    if (nextProps.data.completeness !== this.props.data.completeness) {
      this.setState(({ progress }) => ({ oldProgress: progress, progress: nextProps.data.completeness }));
    }
  }

  render() {
    const { setScroll, menuIds } = this.props;
    const { menuItems, progress, oldProgress } = this.state;

    return (
      <div className="company-form-menu">
        <Scrollspy currentClassName="active" items={menuIds}>
          {map(menuItems, (item, i) => (
            <li key={i} onClick={() => setScroll(item)}>
              {MENU_ITEM_HEADERS[i]}
            </li>
          ))}
        </Scrollspy>

        <div className="company-form-progress-title">
          <CountUp end={progress} start={oldProgress} suffix="% " />
          of profile completed
        </div>

        <div className="company-form-progress">
          <div className="company-form-progress-bar" style={{ width: `${progress}%` }} />
          <div className="company-form-progress-overlay" />
        </div>
      </div>
    );
  }
}
